// extracted by mini-css-extract-plugin
export default {"Container":"CardList_Container__XD-VC"};